/* eslint-disable no-promise-executor-return */
/**
 * 指定された時間分待つ
 *
 * @param ms sleep時間(ミリ秒)
 * @returns
 */
export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
